/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Breadcrumb from '@ion/dls/src/components/breadcrumbs/Breadcrumbs';
import {
  FilterContentGrid,
  FilterContentList
} from './FilterContent';
import FilterHeader from './FilterHeader';
import {
  FilterSelectedOptions,
  FilterSelectedOptionsTitle
} from './FilterSelectedOptions';

export interface FilterExpandContentProps {
  children?: (options: any) => JSX.Element | JSX.Element;
  isOpen?: boolean;
  classes: any;
  hasSelection?: boolean;
  rawCrumbs?: any[];
  handleCrumbBack: () => void;
  crumbData?: JSX.Element;
  optionType: string;
  filterSelectedOptionsCount?: number;
  showSelectedOptionsCount?: boolean;
  filterClearSearch?: boolean;
  filterSelectedOptions?: any;
  filterHashMap?: any;
  filterSearchValue?: string;
  filterContentOptions?: any;
  contentGridTemplateColumns?: string;
  contentJustifyContent?: string;
  contentGridColumnGap?: string;
  contentGridRowGap?: string;
  treeProps?: any;
  setFilterClearSearch?: (clear: boolean) => void;
  handleSearchValueChange?: (value: string) => void;
  handleToggleSelectAll?: (toggle: boolean) => void;
  handleChipDelete?: (itemId: string) => void;
  handleContentGroupSelected?: (itemId: string) => void;
  handleContentOptionSelected?: (itemId: string, selected: boolean) => void;
  clearSearchValue?: () => void;
}

export const FilterExpandContent = ({
  isOpen,
  classes,
  children,
  treeProps,
  rawCrumbs,
  optionType,
  hasSelection,
  filterHashMap,
  contentGridRowGap,
  filterClearSearch,
  contentGridColumnGap,
  filterSelectedOptions,
  contentJustifyContent,
  showSelectedOptionsCount,
  filterSelectedOptionsCount,
  contentGridTemplateColumns,
  crumbData = null,
  filterSearchValue = '',
  filterContentOptions = [],
  handleCrumbBack,
  handleChipDelete,
  clearSearchValue,
  setFilterClearSearch,
  handleToggleSelectAll,
  handleSearchValueChange,
  handleContentGroupSelected,
  handleContentOptionSelected
}: FilterExpandContentProps) => {
  return (
    <div id='menu-content' className={classes.menuContent}>
      <div className={classes.filterHeaderBar}>
        {!hasSelection ? (
          <div className={classes.crumbsContainer}>
            <Breadcrumb icon={(rawCrumbs?.length > 1) && <ChevronLeft className={classes.chevron} />}
              classes={{
                li : classes.crumbList
              }}
              iconClick={handleCrumbBack}>
              {crumbData}
            </Breadcrumb>
          </div>
        ) : (
          <FilterSelectedOptionsTitle optionType={optionType}
            selectedOptionsCount={filterSelectedOptionsCount}
            showSelectedOptionsCount={showSelectedOptionsCount} />
        )}
        <FilterHeader clearSearch={filterClearSearch}
          setClearSearch={setFilterClearSearch}
          onSearchValueChange={handleSearchValueChange}
          onToggleSelectAll={handleToggleSelectAll} />
      </div>
      <div>
        {hasSelection && (
          <div id='chipsContainer' className={classes.chipsContainer}>
            <FilterSelectedOptions selectedOptions={filterSelectedOptions}
              selectedOptionsCount={filterSelectedOptionsCount}
              optionData={filterHashMap}
              onChipDelete={handleChipDelete} />
          </div>
        )}
        {filterSearchValue?.length === 0
          ? <>
            {hasSelection && (
              <div className={classes.crumbsContainer}>
                <Breadcrumb icon={(rawCrumbs?.length > 1) && <ChevronLeft className={classes.chevron} />}
                  classes={{
                    li : classes.crumbList
                  }}
                  iconClick={handleCrumbBack}>
                  {crumbData}
                </Breadcrumb>
              </div>
            )}
            <div className={classes.contentContainer}>
              <FilterContentGrid optionItems={filterContentOptions}
                optionData={filterHashMap}
                onOptionSelected={handleContentOptionSelected}
                onGroupSelected={handleContentGroupSelected}
                contentGridTemplateColumns={contentGridTemplateColumns}
                contentJustifyContent={contentJustifyContent}
                contentGridColumnGap={contentGridColumnGap}
                contentGridRowGap={contentGridRowGap} />
            </div>
          </>
          : (
            <div className={classes.contentContainer}>
              <FilterContentList searchValue={filterSearchValue}
                optionType={optionType}
                optionItems={filterContentOptions}
                optionData={filterHashMap}
                clearSearchValue={clearSearchValue}
                onOptionSelected={handleContentOptionSelected}
                onGroupSelected={handleContentGroupSelected} />
            </div>
          )
        }
      </div>
    </div>
  );
};
